import { DefaultButton, Stack, Text } from "@fluentui/react";

import styles from "./AuthIssueScreen.module.css";

interface AuthIssueScreenProps {
    title: string;
    message: string;
    details?: string;
    onRetry?: () => void;
}

export const AuthIssueScreen = ({ title, message, details, onRetry }: AuthIssueScreenProps) => {
    return (
        <div className={styles.container}>
            <Stack className={styles.card} tokens={{ childrenGap: 14 }}>
                <Text variant="xLargePlus" className={styles.title}>
                    {title}
                </Text>
                <Text variant="medium">{message}</Text>
                {details ? <Text variant="small" className={styles.details}>{details}</Text> : null}
                {onRetry ? <DefaultButton text="Try sign in again" onClick={onRetry} /> : null}
            </Stack>
        </div>
    );
};
